import React from 'react';
import '../styles/WorkWithUs.css';
import ClientTestimonial from '../components/Workwithus/ClientTestimonial';
import PurposeSection from '../components/Workwithus/PurposeSection';
import WhyWorkWithUsSection from '../components/Workwithus/WhyWorkWithUsSection';
import AssetProgressionSection from '../components/Workwithus/AssetProgressionSection';


function WorkWithUs() {
  return (
      <section className='section text-center'>
        <h1>Work With Us</h1>
        <p>
        Introducing JS Property, a premier real estate partnership in Singapore founded by industry veterans Simon Yio and Jen Lee. With over 30 years of combined experience, we specialize in Asset Progression, Portfolio Management, Property Investment, and Property Transactions.
        By leveraging data-driven insights, we offer comprehensive market analyses, enabling our clients to make informed decisions in Singapore's dynamic property landscape.

        </p>

      {/**purpose section */}
      <PurposeSection />

      {/* Asset Progression Plan */}
      <AssetProgressionSection />

      {/* Why Work With Us? */}
      <WhyWorkWithUsSection />

      
      {/* Client Testimonials */}
      <ClientTestimonial />
      
      </section>
  );
}

export default WorkWithUs;